import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import YouTube from 'react-youtube';

import styles from './styles.m.scss';
import videoIcon from '../../../images/video-icon.png';

import Card from '../Card';
import Modal from '../Modal';

class Video extends Component {
  static propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    youtube: PropTypes.string,
  };

  state = {
    showVideo: false,
  };

  render() {
    const { image, title, youtube, ...props } = this.props;
    const { showVideo } = this.state;

    return (
      <Card {...props}>
        <img className={styles.videoIcon} src={videoIcon} />
        <img src={image} />
        <button
          className={cn('btn btn-primary', styles.actionButton)}
          onClick={() => this.setState({ showVideo: true })}
        >
          Watch {title} &gt;
        </button>
        <Modal simple show={showVideo} onHide={() => this.setState({ showVideo: false })}>
          <YouTube videoId={youtube} />
        </Modal>
      </Card>
    );
  }
}

export default Video;
